var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1309_1467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8843 5.31689H9.88428C8.82341 5.31689 7.806 5.73832 7.05585 6.48847C6.3057 7.23861 5.88428 8.25603 5.88428 9.31689V29.3169M5.88428 29.3169V33.3169C5.88428 34.3778 6.3057 35.3952 7.05585 36.1453C7.806 36.8955 8.82341 37.3169 9.88428 37.3169H33.8843C34.9451 37.3169 35.9626 36.8955 36.7127 36.1453C37.4628 35.3952 37.8843 34.3778 37.8843 33.3169V25.3169M5.88428 29.3169L15.0563 20.1449C15.8064 19.395 16.8236 18.9737 17.8843 18.9737C18.9449 18.9737 19.9622 19.395 20.7123 20.1449L25.8843 25.3169M37.8843 17.3169V25.3169M37.8843 25.3169L34.7123 22.1449C33.9622 21.395 32.9449 20.9737 31.8843 20.9737C30.8236 20.9737 29.8064 21.395 29.0563 22.1449L25.8843 25.3169M25.8843 25.3169L29.8843 29.3169M33.8843 5.31689H41.8843M37.8843 1.31689V9.31689M25.8843 13.3169H25.9043",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1309_1467",
    x: 0.884277,
    y: 0.316895,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1309_1467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1309_1467",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.10667c63732aabf74a0173b5421d4931.svg";
export { ForwardRef as ReactComponent };